import React from 'react';
import { Tooltip as MUITooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { colors } from '@roku-web-ui/rds-theme';

export const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MUITooltip
    {...props}
    arrow={false}
    classes={{ popper: className }}
    data-testid="component-tooltip"
    slotProps={{
      popper: {
        disablePortal: true,
      },
    }}
  />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: colors.grey[400],
    backgroundColor: colors.blackout[600],
    border: `1px solid ${colors.grey[800]}`,
  },
  [`&.${tooltipClasses.popper}`]: {
    '&[data-popper-placement^="top"]': {
      [`.${tooltipClasses.tooltip}`]: {
        marginBottom: '6px',
      },
    },
  },
}));
